/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { ViedocDialogElement } from "../../../../../secure/elements/ViedocReactElements";
import { t } from "i18next";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import * as UtilsHelper from "../../../../../../utils/utilsHelper";
import SharedUserForm from "./SharedUserForm";
import SharedUserDisplay from "./SharedUserDisplay";
import DownloadOptions from "./DownloadOptions";
import BinderDetailViewRender from "./BinderDetailViewRender";
import * as documentActions from "../../../../../store/actions/documentActions";
import useDebounce from "../../../../../../hooks/useDebounce";

const FileSharingDialog = ({
  setShowDocsharing,
  docDetailsList,
  isNoBindersAvailable,
}) => {
  const { fullDateTimePattern, dateLocale, isEtmfLocked } = useSelector(
    (state) => state.template
  );
  const [showBinderProperties, setShowBinderProperties] = useState(false);
  const [stepCount, setStepCount] = useState(1);
  const [resetRowData, setResetRowData] = useState(false);
  const [originalRowData, setOriginalRowData] = useState();

  const {
    sharedRecipients,
    docShareCount,
    existingUsersList,
    isBinderDetail,
    isAggridLoading,
    isBindersLoader,
    isDocContentLoader,
    metricsLoader,
    showBinderDetailPage,
  } = useSelector((state) => state.document);

  const { downLoader } = useSelector((store) => store.file);
  const { isDocShareViedocUser, isDocShareViedocMeUser } = useSelector(
    (store) => store.zone
  );

  const dispatch = useDispatch();

  const [showSharedForm, setShowSharedForm] = useState(false);
  const [showNewBinderConfirmation, setshowNewBinderConfirmation] =
    useState(false);
  const [showDownloadOptions, setShowDownloadOptions] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [rowData, setRowData] = useState([{}]);
  const [showSearch, setShowSearch] = useState(false);

  useEffect(() => {
    setShowBinderProperties(showBinderDetailPage);
  }, [showBinderDetailPage]);

  const userType =
    isDocShareViedocMeUser &&
    docDetailsList.trialmasterfilesharingsettings.isenabledforsubjectusers
      ? "Subjects"
      : isDocShareViedocUser &&
        docDetailsList.trialmasterfilesharingsettings.isenabledforclinicalusers
      ? "Clinical User"
      : "";

  const onHide = (e) => {
    e.stopPropagation();
    const reqPayload = {
      documentid: docDetailsList.documentid,
      isForceDataGet: true,
      lastModifiedOn: null,
    };
    dispatch(documentActions.getExistingSharedUsersList(reqPayload));
    setShowDocsharing(false);
  };

  const docList = () => {
    const fileType = docDetailsList?.type;
    let assign = "";
    switch (fileType) {
      case "xlsx":
        assign = "var(--color-forest-50)";
        break;
      case "xls":
        assign = "var(--color-forest-50)";
        break;
      case "pdf":
        assign = "var(--color-fire-50)";
        break;
      case "doc":
        assign = "var(--color-sky-50)";
        break;
      case "docx":
        assign = "var(--color-sky-50)";
        break;
      case "tiff":
        assign = "var(--color-iris-50)";
        break;
      case "tif":
        assign = "var(--color-iris-50)";
        break;
      case "jpg":
        assign = "var(--color-iris-50)";
        break;
      case "jepg":
        assign = "var(--color-iris-50)";
        break;
      case "gif":
        assign = "var(--color-iris-50)";
        break;
      case "png":
        assign = "var(--color-iris-50)";
        break;
      case "bmp":
        assign = "var(--color-iris-50)";
        break;
      case "txt":
        assign = "#c1b9ae";
        break;
      case "rtf":
        assign = "#c1b9ae";
        break;
      case "zip":
        assign = "var(--color-gray-60)";
        break;
      case "xml":
        assign = "#f39b1c";
        break;
      case "yml":
        assign = "#f56233";
        break;
      case "html":
        assign = "#f56233";
        break;
      case "htm":
        assign = "#f56233";
        break;
      case "PPTX":
        assign = "#dc5713";
        break;
      case "PPT":
        assign = "#dc5713";
        break;
      case "MP4":
        assign = "#fa565f";
        break;
      default:
        assign = "var(--color-gray-60)";
        break;
    }
    return assign;
  };

  const fileDetailsHeaderElement = (isDownloadOptionsVisible = true) => {
    const fileDate = fullDateTimePattern
      ? UtilsHelper.getFormattedDateTime(
          fullDateTimePattern,
          docDetailsList?.filedate,
          dateLocale
        )
      : UtilsHelper.momentLocalConversion(docDetailsList?.filedate, true);
    return (
      <div className="binder-doc-info">
        <div className="binder-doc-flex">
          <div>
            <p className="doc-Warning-status" style={{ background: docList() }}>
              <span>{docDetailsList?.type}</span>
            </p>
          </div>
          <div className="flex1 share-doc-title">
            <h2>{docDetailsList?.displaytemplate}</h2>
          </div>
          {isDownloadOptionsVisible && (
            <div>
              {downLoader ? (
                <>
                  <viedoc-spinner size="small" class="spinner"></viedoc-spinner>
                </>
              ) : (
                <button
                  className="cursor-pointer"
                  type="submit"
                  onClick={() =>
                    setShowDownloadOptions((prevState) => !prevState)
                  }
                >
                  <span>...</span>
                </button>
              )}
              {showDownloadOptions && (
                <DownloadOptions
                  isBinderProperties={false}
                  docDetailsList={docDetailsList}
                  setShowDownloadOptions={setShowDownloadOptions}
                  showDownloadOptions={showDownloadOptions}
                />
              )}
            </div>
          )}
        </div>
        <div className="binder-doc-flex share-doc-value">
          <div className="document-conent">
            <div className="wd-45"></div>
            <div className="flex1">
              <div className="share-doc-row d-flex">
                <div className="share-doc-field d-flex">
                  <label>{`${t("DETAILPAGE.LABEL_DOCUMENTVERSION")}: `}</label>
                  <span title={docDetailsList.documentsystemversion}>{docDetailsList.documentsystemversion}</span>
                  <span className="pipe">|</span>
                </div>

                <div className="share-doc-field d-flex">
                  <label>{`${docDetailsList?.datingconventionlabel}: `}</label>
                  <span title={moment(docDetailsList?.datingconventiondate).format(
                      "DD MMM YYYY"
                    )}>
                    {moment(docDetailsList?.datingconventiondate).format(
                      "DD MMM YYYY"
                    )}
                  </span>
                  <span className="pipe">|</span>
                </div>
                <div className="share-doc-row">
                  <div className="share-doc-field d-flex">
                    <label>{`${t("TMF.TEXT_INTEGRITYVALUE")}: `}</label>
                    <span title={docDetailsList?.fileintegrity}>{docDetailsList?.fileintegrity}</span>
                    <span className="pipe">|</span>
                  </div>
                </div>
                <div className="share-doc-field d-flex">
                  <label>{`${t("TMF.TEXT_FILEVERSION")}: `}</label>
                  <span title={docDetailsList?.filesystemversion}>{docDetailsList?.filesystemversion}</span>
                  <span className="pipe">|</span>
                </div>
              </div>
            </div>
          </div>
          <div className="document-conent">
            <div className="wd-45"></div>
            <div className="flex1">
              <div className="share-doc-row d-flex">
                <div className="share-doc-field d-flex">
                  <label>{`${t("TMF.TEXT_ORIGFILENAMELBL")}: `}</label>
                  <span title={docDetailsList?.origfilename}>{docDetailsList?.origfilename}</span>
                  <span className="pipe">|</span>
                </div>
                <div className="share-doc-row">
                  <div className="share-doc-field d-flex">
                    <label>{`${t("TMF.TEXT_FILEDATE")}: `}</label>
                    <span title={fileDate}>
                      {fileDate}
                    </span>
                    <span className="pipe">|</span>
                  </div>
                </div>
                <div className="share-doc-field d-flex">
                  <label>{`${t("TMF.TEXT_FILESIZE")}: `}</label>
                  <span title={UtilsHelper.getFileSize(
                      docDetailsList?.fileSize || docDetailsList?.filesize
                    )}>
                    {UtilsHelper.getFileSize(
                      docDetailsList?.fileSize || docDetailsList?.filesize
                    )}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const NoBinderSection = () => {
    return (
      <>
        <div className="no-binder-section">
          <div className="no-binder-create no-binder-scroll">
            <div className="no-binder-head">
              <ul>
                <li>{t("TMF.LABEL_BINDERID")}</li>
                <li>{t("TMF.LABEL_RECIPIENTS")}</li>
                <li>{t("TMF.LABEL_COSIGNATORY")}</li>
                <li>{t("TMF.TEXT_VERSION")}</li>
                <li>{t("TMF.LABEL_CREATED")}</li>
                <li>{t("TMF.LABEL_VIEWED")}</li>
                <li>{t("TMF.LABEL_SIGNED")}</li>
                <li>{t("TMF.LABEL_STATUS")}</li>
              </ul>
            </div>
            <div className="no-binder-create-btn">
              <div className="no-binder-inner-btn">
                <a
                  className="cursor-pointer"
                  onClick={() => setShowSharedForm(true)}
                >
                  <viedoc-icon name="add" class="no-binert-link-btn" />
                  <span>{t("TMF.TEXT_CREATENEWBINDERS")}</span>
                </a>
              </div>
            </div>
            <div className="no-binder-info-container">
              <viedoc-icon name="info"/>
              <p className="lh1_3">{t("TMF.TEXT_CREATENEWBINDERSINFO")}</p>
            </div>
          </div>
        </div>
      </>
    );
  };

  const searchHandler = (searchTxt) => {
    const searchKey = searchTxt.toLowerCase();
    if (searchKey === "") {
      setResetRowData((prevState) => !prevState);
      return;
    }

    const filteredData = originalRowData.filter(
      (item) =>
        item.binderId.toString().toLowerCase().includes(searchKey) ||
        (Array.isArray(item.recipientsName) &&
          item.recipientsName.some((name) =>
            name.toLowerCase().includes(searchKey)
          )) ||
        (Array.isArray(item.coSignatoriesName) &&
          item.coSignatoriesName.some((name) =>
            name.toLowerCase().includes(searchKey)
          ))
    );
    setRowData(filteredData);
    setSearchText(searchTxt);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSearch = useDebounce(searchHandler, 300);

  const searchInputHandler = (e) => {
    const searchKey = e.target.value;
    setSearchText(searchKey);
    debouncedSearch(searchKey);
  };

  return (
    <ViedocDialogElement
      id="doc-view-popup"
      size="large"
      open
      preventCloseByClick
      onHide={(e) => onHide(e)}
      className="documentSharingView"
    >
      <header slot="header">
        <h2 className="document-header pl-10 mr-10 sharing-doc-header">
          <viedoc-icon name="sharing" />
          {t("TMF.TEXT_FILESHARING")}
        </h2>
      </header>
      {fileDetailsHeaderElement()}
      <div className="share-form">
        <div className="create-binder">
          <>
            {!isBindersLoader &&
              !isAggridLoading &&
              !isDocContentLoader &&
              !metricsLoader && (
                <>
                  {showSharedForm ? (
                    <h2>{t("TMF.TEXT_CREATENEWBINDERS")}</h2>
                  ) : (
                    <h2>{`${docShareCount.availableBindersWithRecalledCount} ${
                      docShareCount.availableBindersWithRecalledCount > 1
                        ? t("TMF.TEXT_BINDERS")
                        : t("TMF.TEXT_BINDER")
                    }`}</h2>
                  )}

                  {showSharedForm ? (
                    <h2 className="step">
                      {showNewBinderConfirmation ? "Step 2/2" : "Step 1/2"}
                    </h2>
                  ) : (
                    !isNoBindersAvailable &&
                    docDetailsList.status === "Finalized" &&
                    ((isDocShareViedocUser &&
                      docDetailsList?.trialmasterfilesharingsettings
                        ?.isenabledforclinicalusers) ||
                      (isDocShareViedocMeUser &&
                        docDetailsList?.trialmasterfilesharingsettings
                          ?.isenabledforsubjectusers)) &&
                    !isEtmfLocked &&
                    !isAggridLoading && (
                      <div className="share-search-main d-flex">
                        <div
                          className={`share-search d-flex ${
                            showSearch ? "search-active" : ""
                          }`}
                        >
                          <div className="share-search-icon">
                            <viedoc-icon
                              name="search"
                              onClick={() =>
                                setShowSearch((prevState) => !prevState)
                              }
                            ></viedoc-icon>
                          </div>

                          <div className="d-flex share-input-search">
                            <input
                              type="text"
                              value={searchText}
                              className="search-input"
                              onChange={(e) => searchInputHandler(e)}
                              onKeyPress={(e) => {
                                if (e.which === 13 && searchText === "") {
                                  setResetRowData((prevState) => !prevState);
                                }
                              }}
                            />
                            <viedoc-icon
                              title="Clear"
                              name="delete"
                              onClick={() => {
                                setResetRowData((prevState) => !prevState);
                                setSearchText("");
                              }}
                            />
                          </div>
                        </div>
                        <p
                          title={t("TMF.TEXT_CREATENEWBINDERS")}
                          className="cursor-pointer"
                          onClick={() => setShowSharedForm(true)}
                        >
                          <viedoc-icon name="add" />
                        </p>
                      </div>
                    )
                  )}
                </>
              )}
          </>
        </div>
        <>
          {isBindersLoader ||
          isAggridLoading ||
          isDocContentLoader ||
          metricsLoader ? (
            <div
              className="d-flex align-center jc-center"
              style={{
                background: "#f3f3f3",
                height: `calc(83vh - 245px)`,
              }}
            >
              <viedoc-spinner />
            </div>
          ) : (
            <>
              {showSharedForm ? (
                <SharedUserForm
                  setShowSharedForm={setShowSharedForm}
                  showNewBinderConfirmation={showNewBinderConfirmation}
                  setshowNewBinderConfirmation={setshowNewBinderConfirmation}
                  recipientTypes={docDetailsList.trialmasterfilesharingsettings}
                  userType={userType}
                  docDetailsList={docDetailsList}
                />
              ) : docShareCount?.availableBindersWithRecalledCount === 0 &&
                !isBinderDetail ? (
                NoBinderSection()
              ) : (
                docShareCount?.availableBindersWithRecalledCount > 0 &&
                !isBinderDetail && (
                  <SharedUserDisplay
                    setShowSharedForm={setShowSharedForm}
                    sharedRecipients={sharedRecipients}
                    docDetailsList={docDetailsList}
                    setShowDownloadOptions={setShowDownloadOptions}
                    setShowBinderProperties={setShowBinderProperties}
                    showDownloadOptions={showDownloadOptions}
                    existingUsersList={existingUsersList}
                    stepCount={stepCount}
                    setStepCount={setStepCount}
                    fileDetailsHeaderElement={fileDetailsHeaderElement}
                    rowData={rowData}
                    setRowData={setRowData}
                    resetRowData={resetRowData}
                    setOriginalRowData={setOriginalRowData}
                  />
                )
              )}
              {showBinderProperties && (
                <BinderDetailViewRender
                  setShowBinderProperties={setShowBinderProperties}
                  docDetailsList={docDetailsList}
                  fileDetailsHeaderElement={fileDetailsHeaderElement}
                  closeSharingDialog={onHide}
                />
              )}
            </>
          )}
        </>
      </div>
      <footer slot="footer"></footer>
    </ViedocDialogElement>
  );
};

export default FileSharingDialog;
